class CustomRedirection extends HTMLElement {
  constructor() {
    super();

    const redirectionStatus = sessionStorage.getItem('redirection_status');

    if (redirectionStatus === 'true') return;
    this.getAllCountries();
    this.checkUserCountry().then(data => {
      const storeCountry = document.querySelector('[data-store-country]')?.innerHTML;
      const country = data.detected_values.country.handle;
      this.countries.forEach(item => {
        if (item.countries_list.includes(country)) {
          if (item.current_country !== storeCountry) {
            this.renderPopup(item);
          }
        }
      })
    }).catch((error) => {
      console.error(error);
    });
    this.popupModalToggle();
  }

  async checkUserCountry() {
    try {
      const response = await fetch(`${window.Shopify.routes.root}browsing_context_suggestions.json`);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      return data;

    } catch (error) {
      console.error('An error occurred:', error);
    }
  }

  getAllCountries() {
    const auTextOne = document.querySelector('[data-au-text-one]')?.innerHTML ? document.querySelector('[data-au-text-one]')?.innerHTML : '';
    const auTextTwo = document.querySelector('[data-au-text-two]')?.innerHTML ? document.querySelector('[data-au-text-two]')?.innerHTML : '';
    const auStoreUrl = document.querySelector('[data-au-store-url]')?.innerHTML ?document.querySelector('[data-au-store-url]')?.innerHTML : '';
    const auRedirectCountries = document.querySelector('[data-au-redirect-countries]')?.innerHTML;
    const auRedirectCountriesList = auRedirectCountries ? auRedirectCountries.split(',') : [];
    const auObj = {
      'current_country': 'AU',
      'text_one': auTextOne,
      'text_two': auTextTwo,
      'store_url': auStoreUrl,
      'countries_list': auRedirectCountriesList
    }

    const usTextOne = document.querySelector('[data-us-text-one]')?.innerHTML ? document.querySelector('[data-us-text-one]')?.innerHTML : '';
    const usTextTwo = document.querySelector('[data-us-text-two]')?.innerHTML ? document.querySelector('[data-us-text-two]')?.innerHTML : '';
    const usStoreUrl = document.querySelector('[data-us-store-url]')?.innerHTML ? document.querySelector('[data-us-store-url]')?.innerHTML : '';
    const usRedirectCountries = document.querySelector('[data-us-redirect-countries]')?.innerHTML;
    const usRedirectCountriesList = usRedirectCountries ? usRedirectCountries.split(',') : [];
    const usObj = {
      'current_country': 'US',
      'text_one': usTextOne,
      'text_two': usTextTwo,
      'store_url': usStoreUrl,
      'countries_list': usRedirectCountriesList
    }

    const ukTextOne = document.querySelector('[data-uk-text-one]')?.innerHTML ? document.querySelector('[data-uk-text-one]')?.innerHTML : '';
    const ukTextTwo = document.querySelector('[data-uk-text-two]')?.innerHTML ? document.querySelector('[data-uk-text-two]')?.innerHTML : '';
    const ukStoreUrl = document.querySelector('[data-uk-store-url]')?.innerHTML ? document.querySelector('[data-uk-store-url]')?.innerHTML : '';
    const ukRedirectCountries = document.querySelector('[data-uk-redirect-countries]')?.innerHTML;
    const ukRedirectCountriesList = ukRedirectCountries ? ukRedirectCountries.split(',') : [];
    const ukObj = {
      'current_country': 'UK',
      'text_one': ukTextOne,
      'text_two': ukTextTwo,
      'store_url': ukStoreUrl,
      'countries_list': ukRedirectCountriesList
    }

    const euTextOne = document.querySelector('[data-eu-text-one]')?.innerHTML ? document.querySelector('[data-eu-text-one]')?.innerHTML : '';
    const euTextTwo = document.querySelector('[data-eu-text-two]')?.innerHTML ? document.querySelector('[data-eu-text-two]')?.innerHTML : '';
    const euStoreUrl = document.querySelector('[data-eu-store-url]')?.innerHTML ? document.querySelector('[data-eu-store-url]')?.innerHTML : '';
    const euRedirectCountries = document.querySelector('[data-eu-redirect-countries]')?.innerHTML;
    const euRedirectCountriesList = euRedirectCountries ? euRedirectCountries.split(',') : [];
    const euObj = {
      'current_country': 'EU',
      'text_one': euTextOne,
      'text_two': euTextTwo,
      'store_url': euStoreUrl,
      'countries_list': euRedirectCountriesList
    }

    this.countries = [auObj, usObj, ukObj, euObj];
  }

  renderPopup(data) {
    const redirectionModal = document.querySelector('#custom-redirection-modal');

    const redirectionModalTextOne = redirectionModal?.querySelector('.crm-text-one');
    const redirectionModalTextTwo = redirectionModal?.querySelector('.crm-text-two');
    const redirectionModalUrl = redirectionModal?.querySelector('#crm-redirection-url');

    const targetUrl = data.store_url + window.location.pathname + window.location.search;

    if (data.text_one && redirectionModalTextOne) redirectionModalTextOne.textContent = data.text_one;
    if (data.text_two && redirectionModalTextTwo) redirectionModalTextTwo.textContent = data.text_two;
    if (data.store_url && redirectionModalUrl) redirectionModalUrl.setAttribute('href', targetUrl);

    window.addEventListener('load', function() {
      redirectionModal?.classList.remove('hidden');
    });

    redirectionModalUrl.addEventListener('click', () => {
      sessionStorage.setItem('redirection_status', 'true');
    })
  }

  popupModalToggle() {
    const redirectionModal = document.querySelector('#custom-redirection-modal');
    const redirectionModalClose = redirectionModal?.querySelector('.crm-close');
    redirectionModalClose.addEventListener('click', () => {
      redirectionModal.classList.add('hidden');
      sessionStorage.setItem('redirection_status', 'true');
    })
  }
}

if (!window.customElements.get('custom-redirection')) {
  customElements.define('custom-redirection', CustomRedirection)
}
